module.exports = __webpack_public_path__ + "static/media/chevron-droite-cercle.6b73a91a.png";